import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import useResume from '../../../hooks/useResume';
import { NoItemView } from '../../NoItemView';
import { IBLSpinLoader } from '../../IBLSpinLoader';
import './Resume.css';


try {
    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
} catch (error) {
    console.log('Failed to set pdfjs worker source:', error);
}

const Resume = ({ username, t }) => {
    const { resume, resumeDataLoaded } = useResume(username);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [scale, setScale] = useState(1.0); // For zoom control
    const [rotation, setRotation] = useState(0); // For rotation control



    if (!resumeDataLoaded) {
        return <IBLSpinLoader size={40} />;
    }

    if (resumeDataLoaded && resume === null) {
        return (
            <NoItemView
                displayMessage={ t("You don't have any resume uploaded yet.")}
                imageUrl={'/images/tools.png'}
                displayPadding={false}
            />
        );
    }

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    // Handlers for controls
    const goToPrevPage = () => setPageNumber(pageNumber - 1);
    const goToNextPage = () => setPageNumber(pageNumber + 1);
    const zoomIn = () => setScale(scale + 0.2);
    const zoomOut = () => setScale(scale > 0.4 ? scale - 0.2 : scale);
    const rotateLeft = () => setRotation(rotation - 90);
    const rotateRight = () => setRotation(rotation + 90);

    return (
        <div>
            <div className="pdf-controls">
                <div className="page-nav">
                    <button onClick={goToPrevPage} disabled={pageNumber <= 1}>
                        Previous Page
                    </button>
                    <span className="page-display">
                        Page {pageNumber} of {numPages}
                    </span>
                    <button onClick={goToNextPage} disabled={pageNumber >= numPages}>
                        Next Page
                    </button>
                </div>

                <div className="zoom-controls">
                    <button onClick={zoomOut} disabled={scale <= 0.4}>
                        -
                    </button>
                    <span className="zoom-display">Zoom: {Math.round(scale * 100)}%</span>
                    <button onClick={zoomIn}>+</button>
                </div>

                <div className="rotation-controls">
                    <button onClick={rotateLeft}>Rotate Left</button>
                    <button onClick={rotateRight}>Rotate Right</button>
                </div>
            </div>

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '80vh',
                }}
            >
                <Document
                    file={resume}
                    onLoadSuccess={onDocumentLoadSuccess}
                    loading={<IBLSpinLoader size={40} />}
                >
                    <Page pageNumber={pageNumber} scale={scale} rotate={rotation} />
                </Document>
            </div>
        </div>
    );
};

export default Resume;
